import { RouteProps } from 'react-router';
import * as React from 'react';
import { Space, Button } from 'antd';

interface ConfirmGroupButtonProps extends RouteProps {
  loading?: boolean;
  onCancel: () => void;
}

export function ConfirmGroupButton(props: ConfirmGroupButtonProps) {
  const { onCancel, loading }: any = props;
  return (
    <Space style={{ float: 'right' }}>
      <Button type="default" onClick={onCancel}>
        İptal
      </Button>
      <Button type="primary" htmlType="submit" loading={loading}>
        Gönder
      </Button>
    </Space>
  );
}
